import { Controller } from "@hotwired/stimulus";

// Inside the tracker detail panel: persists progress edits and depot
// validation changes via the existing PATCH endpoints.
export default class extends Controller {
  static targets = ["progressInput", "validationSelect"];
  static values  = { juniorId: String, parcourId: String };

  async updateProgress(event) {
    const input = event.currentTarget;
    let value = parseInt(input.value, 10);
    if (Number.isNaN(value)) value = 0;
    if (value < 0)   value = 0;
    if (value > 100) value = 100;
    input.value = value;

    const progressId = input.dataset.progressId;
    if (!progressId) return;

    try {
      await fetch(`/juniors/${this.juniorIdValue}/parcours/${this.parcourIdValue}/update_lesson_progresses`, {
        method: "PATCH",
        headers: this._headers(),
        credentials: "same-origin",
        body: JSON.stringify({ progress_id: progressId, progress: value / 100 })
      });
    } catch (_e) { /* silent */ }
  }

  async updateValidation(event) {
    const select = event.currentTarget;
    const depotId = select.dataset.depotId;
    if (!depotId) return;

    try {
      await fetch(`/juniors/${this.juniorIdValue}/parcours/${this.parcourIdValue}/update_depot_fichier`, {
        method: "PATCH",
        headers: this._headers(),
        credentials: "same-origin",
        body: JSON.stringify({ depot_id: depotId, valid: select.value })
      });
    } catch (_e) { /* silent */ }
  }

  _headers() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
    return {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrf,
      Accept: "application/json"
    };
  }
}
